export default "__VITE_ASSET__CjKrJklw__"